import "./RaikoInput.scss"
import PropTypes from "prop-types";


export default function RaikoInput(
	{
		id,
		title,
		placeHolder,
		value,
		onChange,
		error,
		raikoType,
		required = false,
		className,
		type = "text"
	}) {

	return (
		<div className={`inputContainer`}>
			<label
				htmlFor="subject"
				className={"inputTitle"}>{title}
				{required && <span className={"star"}>*</span>}
			</label>
			<input
				placeholder={placeHolder}
				className={`inputMain ${className}`}
				value={value}
				onChange={event => {
					if (raikoType && raikoType.regex) {
						const _value = event.target.value
						if (_value.match(raikoType.regex) !== null || _value.length === 0)
							onChange(event)
					} else {
						onChange(event)
					}
				}}
				type={raikoType ? raikoType.type : type}
				id={id}
			/>
			{error && <span className={"errorMessage"}>* {error}</span>}
		</div>
	)

}


RaikoInput.propTypes = {
	id: PropTypes.string,
	title: PropTypes.string.isRequired,
	value: PropTypes.object.isRequired,
	onChange: PropTypes.func,
	placeHolder: PropTypes.string,
	required: PropTypes.bool
}